
import React from 'react';
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { FileText, BadgeDollarSign, DollarSign } from 'lucide-react';

const HowItWorksPage = () => {
  const steps = [
    {
      icon: FileText,
      title: "Track Expenses",
      description: "Easily log and categorize all your caregiving-related expenses in one place.",
      details: "Our simple expense tracking system helps you capture everything from medical bills to transportation costs, making tax time easier and helping you understand where your money goes."
    },
    {
      icon: BadgeDollarSign,
      title: "Find Savings",
      description: "Discover potential tax deductions, benefits, and cost-saving opportunities.",
      details: "Get personalized recommendations for tax deductions you might be missing, learn about caregiver benefits programs, and find ways to reduce your caregiving costs."
    },
    {
      icon: DollarSign,
      title: "Reduce Stress",
      description: "Gain financial clarity and peace of mind in your caregiving journey.",
      details: "With organized finances and clear insights into your caregiving costs, you can focus more on what matters most - caring for your loved one."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <section className="section-padding">
          <div className="container mx-auto px-4 md:px-6">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 text-careblue-800">How CountedCare Works</h1>
              <p className="text-xl text-muted-foreground">
                A simple, three-step process to help you manage your caregiving finances with confidence.
              </p>
            </div>
            
            <div className="max-w-6xl mx-auto">
              {steps.map((step, index) => (
                <div key={index} className="mb-16 last:mb-0">
                  <div className="flex flex-col lg:flex-row items-center gap-8">
                    <div className="flex-shrink-0">
                      <div className="w-24 h-24 bg-careblue-500 rounded-full flex items-center justify-center mb-4 lg:mb-0">
                        <step.icon className="w-12 h-12 text-white" />
                      </div>
                    </div>
                    <div className="flex-1 text-center lg:text-left">
                      <h2 className="text-3xl font-bold mb-4 text-careblue-800">
                        Step {index + 1}: {step.title}
                      </h2>
                      <p className="text-xl text-muted-foreground mb-4">{step.description}</p>
                      <p className="text-foreground">{step.details}</p>
                    </div>
                  </div>
                  {index < steps.length - 1 && (
                    <div className="flex justify-center my-12">
                      <div className="w-1 h-16 bg-careblue-200"></div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default HowItWorksPage;
